import { render, staticRenderFns } from "./ContactRow.vue?vue&type=template&id=5ad6d2c4&scoped=true&"
import script from "./ContactRow.vue?vue&type=script&lang=js&"
export * from "./ContactRow.vue?vue&type=script&lang=js&"
import style0 from "./ContactRow.vue?vue&type=style&index=0&id=5ad6d2c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad6d2c4",
  null
  
)

export default component.exports